export default __webpack_public_path__ + "static/media/gallerielafayette.d93581e0.png";